module.exports = __webpack_public_path__ + "static/media/office.33583e97.jpg";